module.exports = __webpack_public_path__ + "static/media/cc-dark-circular.0fe31050.png";